/**
 * 紧迫性组件（倒计时、手机号滚动、挽留弹窗）
 */
import { env, ISession, JS2Native, Native2Js, coolHref } from '@utils';
import { mapState, mapActions, mapGetters } from 'vuex';
import Placeholder from '@/components/Prompter/promptPlaceholder';
export default {
  components: {
    Placeholder
  },
  data() {
    /**
     * 售卖流程(1常规 2新一键购 3 微信投放 4 老一键购 5常规一键购)
     */
    return {
      envIsWeChat: env.isWeChat,
      envIsApp: env.isApp,
      // 根据类型判断是否展示优惠倒计时
      showCountdown: [2, 4, 5],
      // 售卖页页名单： courseItem： 常规 老一键购 常规一键购； oneKeyBuyNew：新一键购
      sellPromptPage: ['courseItem', 'oneKeyBuyNew'],
      // 订单支付页名单  h5pay_order：常规；training_camp_order：常规一键购； h5pay_compatible_order：老一键购
      payPromptPage: ['h5pay_order', 'training_camp_order', 'h5pay_compatible_order'],
      orderPromptPageClass: { training_camp_order: '.order_detail_container', h5pay_compatible_order: '.main' },
      // 与售卖页匹配的白名单（form： 售卖页面，to：sellPageToRoute）
      sellPageToRoute: ['shoppingCart', 'shoppingPolymerize'],
      isAlreadyAdded: false,              // 记录是否使用pushState添加过记录
      isFirstEntry: true,                 // 是否是入口页面
    };
  },
  computed: {
    // 是否展示拦截提示框
    ...mapState('course', [
      'immediateStrategyData',      // 倒计时、手机号滚动、挽留弹窗数据
      'isShowSellPrompt',           // 是否展示售卖页挽留弹窗
      'isShowPayPrompt',            // 是否展示支付页挽留弹窗
      'isShowSellCountDown',        // 是否展示售卖页倒计时
      'isShowPayCountDown',         // 是否展示支付页倒计时
      'sellCountDownDuring',        // 售卖页倒计时剩余时间
      'payCountDownDuring',         // 支付页倒计时剩余时间
      'sellDuring',                 // 售卖页倒计时时间
      'payDuring',                  // 支付页倒计时时间
      'isPhoneRoll', 'isLogin']),
    routeName() {
      return this.$route.name;
    },
    // 是否在售卖页拦截名单内
    isSellPromptPage() {
      return this.sellPromptPage.includes(this.routeName);
    },
    // 是否是售卖页
    isSellPage() {
      return this.sellPromptPage.includes(this.routeName);
    },
    // 是否是支付页
    isPayPage() {
      return this.payPromptPage.includes(this.routeName);
    },
    nowPageData() {
      if (this.isPayPage) {
        return this.immediateStrategyData.payJson;
      }
      if (this.isSellPage) {
        return this.immediateStrategyData.sellJson;
      }
    },
    // 是否展示提示框
    isShowPrompt() {
      if (
        (this.isSellPage && this.isShowSellPrompt)
        || (this.isPayPage && this.isShowPayPrompt)
      ) {
        return true;
      }
    }
  },
  destroyed() {
    window.removeEventListener('popstate', this.backPrompt, false);
  },
  created() {
    //  如果为拼团或优惠券前置活动不展示紧迫性组件
    if (this.ptFlag || this.activityId) {
      return;
    }
    this.checkIsFirstEntry();
    // 获取挂件数据
    this.acGetQueryImmediateStrategyData({ goodsId: this.itemid }).then(res => {
      if (!this.isShowPrompt) {
        return;
      }
      if (this.envIsApp) {
        this.setAppSwitchBackIntercept(1);
        this.setAppTriggerBackIntercept();
      } else {
        this.initPrompt();
      }
    });
  },
  methods: {
    ...mapActions('course', [
      'acGetQueryImmediateStrategyData',      // 获取挂件（倒计时、手机号、挽留弹窗）数据
      'acResetPromptShowTime',
      'acSetPopOpenedV1']),              // 保存挽留弹窗出现时间
    // 保存第一次进入的route.name. 防止重复添加历史记录
    getHistoryPage() {
      let name = [];
      if (ISession('already_added_pagename')) {
        name = JSON.parse(ISession('already_added_pagename'));
        this.isAlreadyAdded = name.includes(this.routeName);
      }
      !this.isAlreadyAdded && name.push(this.routeName);
      ISession('already_added_pagename', JSON.stringify(name));
      return name;
    },
    // 判断是否是第一个打开的页面
    checkIsFirstEntry() {
      let firstEntry = ISession('isFirstEntry');
      !firstEntry && (firstEntry = this.$route.meta.firstEntry + '');
      this.isFirstEntry = firstEntry == 1 ? true : false;
      ISession('isFirstEntry', firstEntry);
    },
    // 初始化拦截设置
    initPrompt() {
      // 暂时不支持微信
      if (
        !this.isFirstEntry
        || !this.isSellPromptPage
        || !window.history
        || !window.history.pushState
      ) {
        return;
      }
      this.getHistoryPage();
      // 根据 history.state 判断是否需要添加历史记录
      if (!window.history.state || (window.history.state && !window.history.state.url)) {
        const str = new Date().getTime();
        !this.isAlreadyAdded && window.history.pushState({ url: location.href, stamp: str }, null, location.href);
        this.isAlreadyAdded = true;
      }
      // 监控历史记录变化
      window.addEventListener('popstate', this.backPrompt, false);
    },
    // window.history.pushState 拦截
    backPrompt(val) {
      if (!this.isSellPromptPage || !this.isShowPrompt) {
        return;
      }
      // 商品详情页使用此方法
      // 回到初始页面时，初始页面的indow.history.state可能为空或window.history.state.url不存在，弹出提示
      if (!window.history.state || !window.history.state.url) {
        this.handlePrompter(() => { window.history.forward() }, this.handelJump);
      }
    },
    handlePrompter(cancelFun = () => {}, confirmFun = () => {}, container = '', closeFun) {
      const h = this.$createElement;
      const imgUrl = this.nowPageData?.popup?.imgUrl;
      this.$prompter.hide();
      this.promptLogTrack({ module_name: '挽留弹窗' }, 'show');
      this.$prompter.show(
        {
          el: container,
          round: true,
          closeOnClickOverlay: false,
          styleOptions: { background: 'none' },
          content: h('Placeholder', {
            props: {
              placeholder: imgUrl
            },
            on: {
              onCancel: () => {
                cancelFun && cancelFun();
                this.$prompter.hide();
                this.promptLogTrack({ module_name: '挽留弹窗', btn_name: '热区一' }, 'click');
              },
              onConfirm: () => {
                confirmFun && confirmFun({});
                this.$prompter.hide();
              },
            }
          }),
          onOpen: () => {
            this.acResetPromptShowTime();
            this.isLogin && this.acSetPopOpenedV1();
          },
          onClose: () => {
            closeFun && closeFun();
          }
        }
      );
    },
    // 通用的挽留弹窗开关接口  https://wiki.luojilab.com/pages/viewpage.action?pageId=58660543#id-%E5%AE%A2%E6%88%B7%E7%AB%AF%E5%B0%91%E5%B9%B4%E5%BE%97%E5%88%B0Js2Native%E6%8E%A5%E5%8F%A3%E6%96%87%E6%A1%A3-%E9%80%9A%E7%94%A8%EF%BC%9A%E6%8C%BD%E7%95%99%E5%BC%B9%E6%A1%86%E5%BC%80%E5%85%B3%E3%80%81%E5%90%8E%E9%80%80%E6%8B%A6%E6%88%AA%E5%BC%80%E5%85%B3
    setAppSwitchBackIntercept(status) {
      JS2Native({
        name: 'switchBackIntercept',
        params: {
          holdon: status || 0,  // 0: 不需要挽留弹窗 1: 需要挽留弹窗
        }
      });
    },
    // H5需要挽留弹窗
    setAppTriggerBackIntercept() {
      Native2Js({
        name: 'triggerBackIntercept',
      }, () => {
        // 如果存在提示框，不再重新提示
        if (this.$prompter.state()) {
          return;
        }
        this.handlePrompter(
          () => {
            this.setAppSwitchBackIntercept();
            // 点击取消直接关闭壳子
            JS2Native({
              name: 'closeWindow'
            });
          },
          () => {
            this.setAppSwitchBackIntercept();
            this.handelJump({});
          });
      });
    },
    // 拦截弹窗跳转
    handelJump({ callback = undefined, next = undefined }) {
      let type = 0, url = '';
      (type = this.nowPageData?.popup?.navToCode) && (url = this.nowPageData?.popup?.customLink);
      this.jumpAction({ type, url, callback, next });
    },
    // 跳转导航：1-自定义链接,2-引导下载app,3-引导添加公众号,4-停留在当前页面
    jumpAction({ type, url, callback, next }) {
      this.promptLogTrack({ module_name: '挽留弹窗', btn_name: '热区二', key1: { purpose_of_retention: type } }, 'click');
      if (type === 1) {
        coolHref(url);
      } else if (!this.envIsApp && type === 2) {
        window.location.href = 'https://igetcool-share.igetcool.com/download';
      } else if (type === 3) {
        this.$router.push({ path: '/mall/strategyAddWechat' });
      } else {
        callback && callback();
      }
    },
    // 埋点
    promptLogTrack(params, action) {
      this.setLogTrack && this.setLogTrack(params, action); // 在主文件中定义的
    }
  },
  beforeRouteEnter(to, from, next) {
    // 通过from来判断是不是首次进入页面，如果是首次，则使用pushState，反之使用路由监听
    if (from.fullPath === '/') {
      to.meta.firstEntry = 1;
    } else {
      to.meta.firstEntry = 0;
    }
    next();
  },
  beforeRouteLeave: function(to, from, next) {
    const orderRouter = this.payPromptPage;
    const goodsRouter = this.sellPromptPage;
    if (this.envIsApp || !this.isShowPrompt) {
      next();
      return;
    }
    if (
      // 从订单详情来， 到商品详情去
      (goodsRouter.includes(to.name) && orderRouter.includes(from.name))
      // 从商品详情来， 到配置的白名单路由内去处去
      || (goodsRouter.includes(from.name) && this.sellPageToRoute.includes(to.name))
    ) {
      let className = this.orderPromptPageClass[from.name] || '';
      this.handlePrompter(
        () => next(),
        () => { next(false); this.handelJump({ next }) },
        className
      );
    } else {
      next();
    }
  }
};